
	import { ref, defineComponent, computed, getCurrentInstance, watch, reactive, toRaw, onMounted } from 'vue'
	import { useStore } from 'vuex'
	import { addSeat, getSeatList } from '../request'
	import { message } from 'ant-design-vue'
	import { modalState } from '../config'
	import moment from 'moment'
	import deepClone from 'library/functions/deepClone'
	import _ from 'lodash'
	import { getCallLine } from '../../business/request'
	import { seatColumns } from '../config'
	import { UsePageDto } from '@/common/mixins/listPageDto'
	import { useTableScroll } from '@/common/mixins/useTableScroll'

	export default defineComponent({
		props: {
			type: {
				type: String,
				default: 'add'
			},
			value: {
				type: Object,
				default: () => ({})
			}
		},
		emits: ['close'],
		setup(props, { emit }) {
			const store = useStore()
			const isView = computed(() => props.type === 'view')
			const isEdit = computed(() => props.type === 'edit')
			const filter = reactive({})
			const data = ref([])

			const instance = getCurrentInstance()
			const { scroll } = useTableScroll(instance)
			const { pagination, listPageDto, handleTableChange, refresh } = UsePageDto(instance)

			const loading = ref<boolean>(false)
			const afterClose = () => {
				emit('close')
			}

			const columns: any = ref([])
			if (isView.value) {
				columns.value = [
					...seatColumns,
					{
						title: '已被使用企业',
						dataIndex: 'name',
						width: 120
					}
				]
			} else {
				columns.value = [...seatColumns]
			}

			const seats = ref([])
			const showPage = ref(true)

			function customUploadRequest({ file }) {
				console.log(file)
				if (file?.percent === 100 && file?.xhr && file?.xhr?.status === 200) {
					const res = JSON.parse(file?.xhr?.responseText)
					console.log(res)
					if (res.code === 0) {
						data.value = res.data
						seats.value = res.data
						showPage.value = false
					}
				}
			}

			const onSubmit = () => {
				if (!seats.value.length) {
					message.warn('请上传坐席表')
					return
				}
				addSeat({ num: props.value?.num, seats: seats.value }).then(() => {
					afterClose()
				})
			}

			// 获取列表
			const fetchList = async () => {
				const params = {
					num: props.value?.num,
					pageDto: {
						pageNum: listPageDto.pageNum,
						pageSize: 10
					}
				}
				loading.value = true
				try {
					showPage.value = true

					const res = await getSeatList(params)
					loading.value = false
					data.value = res.data
					Object.assign(listPageDto, res.pageDto)
				} catch (e) {
					loading.value = false
				}
			}

			onMounted(async () => {
				fetchList()
			})

			return {
				store,
				loading,
				afterClose,
				modalState,
				seatColumns,
				isView,
				isEdit,
				scroll,
				data,
				handleTableChange,
				pagination,
				fetchList,
				customUploadRequest,
				onSubmit,
				filter,
				showPage,
				columns
			}
		}
	})
